"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFullscreen = void 0;
const react_1 = require("react");
const MapContext_1 = require("../MapContext");
function useFullscreen() {
    const { fullscreen } = react_1.useContext(MapContext_1.MapContext);
    return fullscreen;
}
exports.useFullscreen = useFullscreen;
//# sourceMappingURL=useFullscreen.js.map